function isDict(v) {
  /**
   * Функция проверяет является ли входной параметр обычным объектом
   * @param {Object} v - входной параметр
   * @return {boolean} true если параметр является объектом иначе false
   */
    return typeof v==='object' && v!==null && !(v instanceof Array) && !(v instanceof Date);
}

export default {
    data() {
        return {
            errors: {
                fields: {},
                non: []
            },
            scrolled: false,
        }
    },
    methods: {
        setNotScrolled: function () {
          /**
           * Устанавливает значение scrolled на false
           */
            this.scrolled = false;
        },
        setScrolled: function () {
          /**
           * Устанавливает значение scrolled на true
           */
            this.scrolled = true;
        },
        mapErrors: function (data) {
          /**
           * Обрабатывает ошибки формы из ответа сервера
           * @param {Object} data - Ошибки в формате
           */
            if ('non_field_errors' in data)
                this.addNonFieldError(data['non_field_errors']);
            this.setNotScrolled();
            this.errors.fields = data;
        },
        hasError: function (field, errors=undefined) {
          /**
           * Проверяет есть ли ошибки у поля
           * @param {Object} field - Объект поля
           * @returns {boolean} true если есть ошибки
           */
            let result = this.getError(field) !== null;
            if (result && !this.scrolled) {
                if (this.$refs[field]) {
                    this.setScrolled();
                    let ref = this.$refs[field];
                    if (Array.isArray(this.$refs[field]))
                        ref = ref[0];
                    ref.$el.scrollIntoView();
                }
            }
            return result
        },
        getError: function (field, errors=undefined) {
          /**
           * Получает ошибки поля
           * @param {Object} field - Объект поля
           * @returns {Array|null} Массив ошибок или null
           */
            // console.log(field, errors)
            if(errors === undefined)
                errors = this.errors.fields
            for (let val in errors){
                if (isDict(errors[val])) {
                    // console.log()
                    if (field !== undefined && field !== null && field.includes('.')) {
                        return this.getError(field.split('.').slice(1).join('.'), errors[val]);
                    }
                }
                if((errors[val]).length > 0)
                    if(val === field)
                        return errors[val];
            }
            return null;
        },
        deleteError: function (field, id = undefined) {
          /**
           * Удаляет ошибки поля
           * @param {Object} field - Объект поля
           */
            delete this.errors.fields[field];
            if (id !== undefined) {
                this.$delete(this.errors.fields[id], field);
                if (Object.keys(this.errors.fields[id]).length === 0) {
                    this.$delete(this.errors.fields, id);
                }
            } else {
                delete this.errors.fields[field];
            }
        },
        deleteNonFieldError: function (error) {
          /**
           * Удаляет общую ошибку
           * @param {string} error - Текст ошибки
           */
            let errors = this.errors.non;
            errors.splice(errors.indexOf(error), 1);
            this.$set(this.errors, 'non', errors);
        },
        addNonFieldError: function (error) {
          /**
           * Добавляет общую ошибку
           * @param {string|Array} error - Ошибка или массив ошибок
           */
            let errors = this.errors.non;
            if (errors.indexOf(error))
                errors.push(error);
            this.$set(this.errors, 'non', errors);
            // this.show_non_field_errors = true;
        },
        getNonFieldErrors: function () {
          /**
           * Возвращает общие ошибки
           * @returns {Array} Массив общих ошибок
           */
            return this.errors.non
        }
    }
}
